import { render } from "./TaskModal.vue?vue&type=template&id=4e92532e&scoped=true&ts=true"
import script from "./TaskModal.ts?vue&type=script&lang=ts"
export * from "./TaskModal.ts?vue&type=script&lang=ts"

import "./TaskModal.scss?vue&type=style&index=0&id=4e92532e&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e92532e"]])

export default __exports__